export const MSPR_ORG_TYPE_CUSTOM = '#custom';

export const MSPR_PROVIDER_TYPES = {
    THIRD_PARTY: 'THIRD_PARTY',
    FOURTH_PARTY: 'FOURTH_PARTY',
    BOTH: 'BOTH',
} as const;

export type MsprProviderType = (typeof MSPR_PROVIDER_TYPES)[keyof typeof MSPR_PROVIDER_TYPES];

export const MSPR_PROVIDER_TYPE_LABELS = {
    [MSPR_PROVIDER_TYPES.THIRD_PARTY]: '3rd party',
    [MSPR_PROVIDER_TYPES.FOURTH_PARTY]: '4th party that supports at least one 3rd party provider',
    [MSPR_PROVIDER_TYPES.BOTH]: 'Both 3rd and 4th party',
} as const;

export const MSPR_EXPOSURE_TYPES = {
    CRITICAL_OPERATION: 'CRITICAL_OPERATION',
    MATERIAL_OPERATION_RISK: 'MATERIAL_OPERATION_RISK',
} as const;

export type MsprExposureType = (typeof MSPR_EXPOSURE_TYPES)[keyof typeof MSPR_EXPOSURE_TYPES];

export const MSPR_EXPOSURE_TYPE_LABELS = {
    [MSPR_EXPOSURE_TYPES.CRITICAL_OPERATION]: 'Critical operation',
    [MSPR_EXPOSURE_TYPES.MATERIAL_OPERATION_RISK]: 'Material operation risk',
} as const;

export const MSPR_GOVERNANCE_ASSESSMENT_RESULTS = {
    PASS: 'PASS',
    CONDITIONAL_PASS: 'CONDITIONAL_PASS',
    FAIL: 'FAIL',
} as const;

export const MSPR_GOVERNANCE_ASSESSMENT_RESULT_LABELS = {
    [MSPR_GOVERNANCE_ASSESSMENT_RESULTS.PASS]: 'Pass',
    [MSPR_GOVERNANCE_ASSESSMENT_RESULTS.CONDITIONAL_PASS]: 'Conditional pass',
    [MSPR_GOVERNANCE_ASSESSMENT_RESULTS.FAIL]: 'Fail',
} as const;

export type MsprGovernanceAssessmentResult =
    (typeof MSPR_GOVERNANCE_ASSESSMENT_RESULTS)[keyof typeof MSPR_GOVERNANCE_ASSESSMENT_RESULTS];

export const MSPR_GOVERNANCE_FREQUENCY = {
    ANNUAL: 'Annual',
    BIANNUAL: 'Biannual',
    QUARTERLY: 'Quarterly',
    MONTHLY: 'Monthly',
    WEEKLY: 'Weekly',
    AD_HOC: 'Ad-hoc',
    ON_DEMAND: 'On-demand',
    CONTINUOUS: 'Continuous',
    AS_REQUIRED: 'As required',
} as const;

export type MsprGovernanceFrequency = keyof typeof MSPR_GOVERNANCE_FREQUENCY;
